import React, { useCallback, useState } from 'react';
import { createContext, useContext } from 'react';

type CustomizeMenuContextProps = {
  isShowMenu?: boolean;
  setIsShowMenu: (isShowMenu?: boolean) => { cleanup: () => void };
};

const CustomizeMenuContext = createContext<CustomizeMenuContextProps>({
  isShowMenu: undefined,
  setIsShowMenu: () => ({
    cleanup: () => {
      return;
    },
  }),
});

export const useMenuContext = (): CustomizeMenuContextProps => {
  const context = useContext(CustomizeMenuContext);

  return context;
};

export const CustomizeMenuProvider = (props: { children: React.ReactNode }) => {
  const [isShowMenu, setIsShowMenu_] = useState<boolean | undefined>();
  const setIsShowMenu = useCallback((isShowMenu?: boolean) => {
    setIsShowMenu_(isShowMenu);
    return { cleanup: () => setIsShowMenu_(undefined) };
  }, []);
  return (
    <>
      <CustomizeMenuContext.Provider
        value={{
          setIsShowMenu,
          isShowMenu,
        }}>
        {props.children}
      </CustomizeMenuContext.Provider>
    </>
  );
};
